/** @file The option divider. */
import * as tsx from 'vue-tsx-support';
/** The divider component used in the option component of the choice components. */
export const Divider = tsx.component({
    name: 'option-divider',
    functional: true,
    /** @returns The divider element. */
    render() {
        return <hr class="m-0 border-t"/>;
    },
});
